import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

/**
 * Tooltip para IconButton em fileiras densas (Receber / Asaas / Excluir).
 * Envolve o botão em span para ref estável e evita bloqueio de clique entre vizinhos.
 */
export function ActionIconTooltip({
  title,
  children,
  ...rest
}: TooltipProps & { children: React.ReactElement }) {
  return (
    <Tooltip title={title} disableInteractive enterDelay={450} {...rest}>
      <span style={{ display: 'inline-flex', verticalAlign: 'middle', lineHeight: 0 }}>
        {children}
      </span>
    </Tooltip>
  );
}

export default ActionIconTooltip;
